import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { AuthWrapper } from "./components/AuthWrapper";

/** IMPORTANT - DO NOT CHANGE THE ORDERING BELOW. The app.core.scss is the base style of the application, and IT MUST BE LOADED BEFORE we import the App.js; otherwise, the css will compiled in a different order which will affect the look and feel. */
import './components/styles/app.core.scss';
import App from './components/App';
/** IMPORTANT - DO NOT CHANGE THE ORDERING ABOVE. */

const AppWrapper = () => {
    return <AuthWrapper>
            <App/>
        </AuthWrapper>;
};

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
